<template>
  <div class="mt-3">
    <v-container>
      <v-row>
        <v-col cols="4">
          <v-card class="pa-3 position-static d-flex flex-column align-center">
            <ItemsCarousel/>
            <RequestStatus @open="showView($event)"/>
          </v-card>
        </v-col>
        <v-col>
          <div class="fill-height">
            <v-card class="fill-height" light>
              <RequestInvoiceDesktop @open="showView($event)"/>
              <RequestOptions @open="showView($event)"/>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-navigation-drawer class="px-7 py-12" fixed right temporary v-model="views.schedule" width="550">
      <div class="text-h6 mb-8">Schedule</div>
      <RequestSchedule :schedule="request.request_schedule" @close="closeViews()"/>
    </v-navigation-drawer>

    <v-navigation-drawer fixed right temporary v-model="views.payment" width="550">
      <Payment @close="closeViews()"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="views.eligibility" fixed right temporary width="550">
      <EligibilityWidget v-if="views.eligibility" @done="reset()" @cancel="views.eligibility = false"/>
    </v-navigation-drawer>

    <v-navigation-drawer fixed right temporary v-model="views.data" width="550">
      <DataWidget @done="reset()"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="views.repayment" fixed right temporary width="550">
      <RepaymentWidget @close="closeViews()" @done="reset()"/>
    </v-navigation-drawer>

    <v-navigation-drawer fixed right temporary v-model="views.email" width="550">
      <VerifyEmail @close="closeViews()" @done="reset()"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
	import RequestSchedule from "./RequestSchedule";
	import request from "../../mixins/request";
	import views from "../../mixins/views";
	import Payment from "../Payment";
	import VerifyEmail from "./VerifyEmail";
	import EligibilityWidget from "@/components/request/EligibilityWidget";
	import RepaymentWidget from "@/components/request/RepaymentWidget";
	import RequestOptions from "./RequestOptions";
	import RequestInvoiceDesktop from "./RequestInvoiceDesktop";
	import ItemsCarousel from "./ItemsCarousel";
	import DataWidget from "./DataWidget";
	import RequestStatus from "./RequestStatus";

	export default {
		name: 'RequestDesktop',
		mixins: [request, views],
		components: {
			RequestStatus,
			DataWidget,
			ItemsCarousel,
			RequestInvoiceDesktop,
			RequestOptions,
			RepaymentWidget,
			EligibilityWidget,
			VerifyEmail,
			Payment,
			RequestSchedule,
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/variables';

  .container--fluid {
    margin-top: var(--nav-spacing);
    height: calc((var(--vh, 1vh) * 100) - var(--nav-spacing));
  }
</style>
